import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getCountryList, getStationsForCountry } from '../../features/railStations/railStationSlice';
import {
    Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverFooter, PopoverBody, PopoverCloseButton,
    Box, Flex, Stack, Button, Text, LinkBox, LinkOverlay, useDisclosure
} from '@chakra-ui/react';
import Select from 'react-select';

const customSelectStyles = {
    control: (provided) => ({
        ...provided,
        borderColor: 'gray.300',
        boxShadow: 'none',
        '&:hover': { borderColor: 'gray.400' },
    }),
};

export default function CountryStationSelector({ onSelectStation }) {
    const { countries, stationsForCountry } = useSelector((state) => state.stations);
    const dispatch = useDispatch();
    const { isOpen, onOpen, onClose } = useDisclosure();

    useEffect(() => {
        dispatch(getCountryList());
    }, [dispatch]);

    const handleCountrySelectChange = (e) => {
        dispatch(getStationsForCountry(e.value));
    };

    const onAdvancedStationSelect = (e) => {
        const station = stationsForCountry.find((station) => station.value === e.value);
        if (station) {
            const newStation = {
                name: station.label,
                _id: station.value,
                latitude: station.latitude,
                longitude: station.longitude,
                country: station.country,
            };
            onSelectStation(newStation);
            onClose();
        }
    };

    return (
        <Popover isOpen={isOpen} onClose={onClose} placement='right' closeOnBlur={false}>
            <PopoverTrigger>
                <LinkBox>
                    <LinkOverlay
                        onClick={onOpen}
                    >
                        <Box
                            align='center'
                        >
                            <Text
                                fontSize='sm'
                                color='blue.900'
                                as='u'
                            >
                                Select station by country
                            </Text>
                        </Box>
                    </LinkOverlay>
                </LinkBox>
            </PopoverTrigger>
            <Flex align='stretch'>
                <Box zIndex='popover'>
                    <PopoverContent borderRadius='lg'>
                        <PopoverHeader>
                            <Text fontWeight='bold'>Select station by country</Text>
                            <PopoverCloseButton />
                        </PopoverHeader>
                        <PopoverBody>
                            <Stack spacing={4}>
                                <Select
                                    placeholder='Country'
                                    isDisabled={!countries || countries.length === 0}
                                    options={countries}
                                    onChange={handleCountrySelectChange}
                                    styles={customSelectStyles}
                                />
                                <Select
                                    placeholder='Station'
                                    isDisabled={!stationsForCountry || stationsForCountry.length === 0}
                                    options={stationsForCountry}
                                    onChange={onAdvancedStationSelect}
                                    styles={customSelectStyles}
                                />
                            </Stack>
                        </PopoverBody>
                        <PopoverFooter>
                            <Button w='full' colorScheme='blue' variant='outline' onClick={onClose}>
                                Select station
                            </Button>
                        </PopoverFooter>
                    </PopoverContent>
                </Box>
            </Flex>
        </Popover>
    );
};